module.exports = __webpack_public_path__ + "img/icone_vivinho.72645240.svg";